























import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Point, Size, Rectangle } from "../../../../../../base/domain/drawing";
import { FormatPageStructureEditor } from "../../../../../domain/editableFormat";
import { instanceOfILocationPropertyPresentable, instanceOfISizePropertyPresentable } from "../../../../../domain/editableFormat/properties";
import { FormatPageMouseTrackableMixin } from "./mixins";
import { QuestionnaireFormatObject } from "../../../../../domain/questionnaire/constants";

@Component
export default class QuestionnaireFormatPageObjectsSelector extends Mixins(FormatPageMouseTrackableMixin) {
  data() {
    return {
      isIndicatable: false,
      from: null as Point,
      calculateY: 0,
    };
  }
  isIndicatable: boolean;
  from: Point;
  calculateY: number;

  get isSelecting(): boolean {
    return !!this.from;
  }

  select(event: PointerEvent): void {
//    console.log("範囲選択開始");
    this.from = this.toClientLocation(this.pageElement, event);
    setTimeout(() => {
      if (this.isSelecting) {
        this.isIndicatable = true;
      }
    }, 100);  // クリックしただけだとちらついて見えるので描画開始はちょっと待つ.
  }

  cancel(): void {
//    console.log("範囲選択中止");
    this.from = null;
    this.isIndicatable = false;
  }

  handleMouseEntered(event: PointerEvent): void {
    this.onMouseEntered(this.pageElement, event);
  }

  handleMouseMoved(event: PointerEvent): void {
    this.onMouseMoved(this.pageElement, event);
  }

  handleMouseLeaved(event: PointerEvent): void {
    this.onMouseLeaved(this.pageElement, event);
  }

  handleMousePressed(event: PointerEvent): void {
    this.onMousePressed(this.pageElement, event);
  }

  handleMouseReleased(event: PointerEvent): void {
    this.onMouseReleased(this.pageElement, event);
    this.finish();
  }

  private finish(): void {
//    console.log("範囲選択完了");
    this.writePropertyWhenValid(s => {
      const editor = s as FormatPageStructureEditor;
      this.calculateY = QuestionnaireFormatObject.Gap;
      Enumerable.from(editor.getObjects())
        .select(o => {
          if (instanceOfILocationPropertyPresentable(o) && instanceOfISizePropertyPresentable(o))  {
            const rectangle = new Rectangle(new Point(0, this.calculateY), Size.from(o.size().getValue()));
            this.calculateY += rectangle.size.height + QuestionnaireFormatObject.Gap;
            return { obj: o, rect: rectangle };
          }
          return null;
        })
        .where(o => o && this.selectingRectangle.overlapsVertical(o.rect))
        .select(o => o.obj)
        .toArray()
        .forEach(o => {
          const clone = o.clone();
          clone.select();
          editor.updateObject(clone);
        });
    });
    this.from = null;
    this.isIndicatable = false;
  }

  @Watch("isMouseTracking")
  onMouseTrackingChanged(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.finish();
    }
  }

  get selectingRectangle(): Rectangle {
    return (this.isSelecting && this.mouseLocation)
      ? Rectangle.from([this.from, this.mouseLocation])
      : new Rectangle(new Point(0, 0), new Size(0, 0));
  }
}
